import { render, staticRenderFns } from "./resetPasswordPopup.vue?vue&type=template&id=da717864&scoped=true&"
import script from "./resetPasswordPopup.vue?vue&type=script&lang=js&"
export * from "./resetPasswordPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da717864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
